import { useState, useEffect, useRef } from "react";
import { gsap } from "gsap";

interface SpinningWheelProps {
  onSpinComplete: () => void;
  isSpinning: boolean;
}

export function SpinningWheel({ onSpinComplete, isSpinning }: SpinningWheelProps) {
  const [spinning, setSpinning] = useState(false);
  const spinTimelineRef = useRef<gsap.core.Timeline | null>(null);
  const blurTimelineRef = useRef<gsap.core.Timeline | null>(null);

  // Cleanup function for GSAP animations
  const cleanupAnimations = () => {
    console.log("Cleaning up GSAP animations");
    if (spinTimelineRef.current) {
      spinTimelineRef.current.kill();
      spinTimelineRef.current = null;
    }
    if (blurTimelineRef.current) {
      blurTimelineRef.current.kill();
      blurTimelineRef.current = null;
    }
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      console.log("SpinningWheel unmounting, cleaning up animations");
      cleanupAnimations();
    };
  }, []);

  const handleSpin = () => {
    if (spinning) return;

            const audio = new Audio('/sfx/wheel.aac');
            audio.play();

    const audio2 = new Audio('/sfx/winning.aac');
    setTimeout(() => {
      audio2.play();
    }, 8500); // Delay of 2000ms (2 seconds)

    setTimeout(() => {
        onSpinComplete();
        console.log("Spin animation complete");
        setSpinning(false);
    }, 6000); // Delay of 2000ms (2 seconds)
    
    console.log("Starting spin animation");
    cleanupAnimations();
    setSpinning(true);

    gsap.to("#stars1, #stars2", { opacity: 1, duration: 0.1 });

    spinTimelineRef.current = gsap.timeline({
      repeat: 0,
    //  onComplete: () => {
    //    onSpinComplete();
    //    console.log("Spin animation complete");
    //    setSpinning(false);
    //  }
    });

    blurTimelineRef.current = gsap.timeline({ repeat: 0 });

    spinTimelineRef.current
      .to(".wheelG2", { filter: "blur(8px)", rotation: "-=3600", duration: 6.0, ease: "power1.inOut" })
      .to(".wheelG2", { filter: "blur(0px)" }, "-=0.9")
      .to(".wheelG2", { rotation: "+=40", duration: 1.0, ease: "power1.inOut" })
      .to(".wheelG2", { rotation: "-=10", duration: 1.0, ease: "power1.inOut" })
      .fromTo(
        "#wheel3, #wheel4, #stars1, #stars2 ",
        { scale: 0.5, opacity: "0" },
        { scale: 1, opacity: "1", duration: 1.5, ease: "elastic.out(1, 0.5)" },
        "-=2.4"
      )
     // .from("#stars1", { scale: 0, duration: 1.0, ease: "elastic.out(1, 0.5)" }, "-=1.2")
     // .from("#stars2", { scale: 0, duration: 1.0, ease: "elastic.out(1, 0.5)" }, "-=1.1");

    blurTimelineRef.current
      .to(".wheelG2", { filter: "blur(5px)", duration: 6.0, ease: "power2.inOut" })
      .to(".wheelG2", { filter: "blur(0px)", duration: 1 }, "-=1.0");
  };

  return (
    <div className="flex flex-col items-center gap-6 mt-[8vh]" onClick={!spinning ? handleSpin : undefined}>
      <div className="wheelG2">
        <div className="flex flex-col items-center wheelG w-[1100px] h-[1100px]">
          <img src="/imgs/wheel.jpg" alt="wheel" className="w-[1100px] h-[1100px] absolute" id="wheel" />
          <img src="/imgs/p1.png" alt="prize" className="w-[1100px] h-[1100px] absolute prizes" id="prize1" />
          <img src="/imgs/p2.png" alt="prize" className="w-[1100px] h-[1100px] absolute prizes" id="prize2" />
          <img src="/imgs/p3.png" alt="prize" className="w-[1100px] h-[1100px] absolute prizes" id="prize3" />
          <img src="/imgs/p4.png" alt="prize" className="w-[1100px] h-[1100px] absolute prizes" id="prize4" />
          <img src="/imgs/p5.png" alt="prize" className="w-[1100px] h-[1100px] absolute prizes" id="prize5" />
          <img src="/imgs/p6.png" alt="prize" className="w-[1100px] h-[1100px] absolute prizes" id="prize6" />
          <img src="/imgs/p7.png" alt="prize" className="w-[1100px] h-[1100px] absolute prizes" id="prize7" />
          <img src="/imgs/p8.png" alt="prize" className="w-[1100px] h-[1100px] absolute prizes" id="prize8" />
          <img src="/imgs/wheel3.png" alt="wheel" className="w-[1100px] h-[1100px] absolute" id="wheel3" />
          <img src="/imgs/wheel4.png" alt="wheel" className="w-[1100px] h-[1100px] absolute" id="wheel4" />
          <img src="/imgs/star1.png" alt="stars" className="w-[1100px] h-[1100px] absolute" id="stars1" />
          <img src="/imgs/star2.png" alt="stars" className="w-[1100px] h-[1100px] absolute" id="stars2" />
        </div>
      </div>

      <div
        className={`flex justify-center items-center  mt-[-140px] ${spinning ? 'opacity-50' : ''}`}
        id="btn1_G_Price"
        onClick={!spinning ? handleSpin : undefined}
      >
        <div className="button_spinG">
          <div className="button-container flex justify-center items-center">
            <div className="button button_spin">
              <div className="button-top-rect"></div>
              <div className="button-bottom-rect"></div>
              <span className="button-text font-Metric">SPIN TO WIN!</span>
            </div>
          </div>
        </div>
      </div>
      <p className="text-center text-4xl text-white z-10 mt-[20px] spinCopy">
        Spin the wheel to get your prize!
      </p>
    </div>
  );
}